import clamp from 'lodash/clamp.js'

export type AvatarDims = [
	borderWidth: number,
	boxPadding: number,
	innerRadius: number,
	innerSize: number,
	outerRadius: number,
]

/**
 * Calculates the dimensions for an Avatar wrapper component given a size. This exists only to
 * provide consistent dimensions across Avatar usages.
 *
 * @param size - The size of the avatar.
 * @param disableWrapper - Whether to disable wrapper styles. Used when we just want the avatar
 *  without the border styles and padding associated with those styles.
 * @param padding - Whether to enable padding.
 * @param radius - Whether to enable border radius.
 * @returns The dimensions tuple for the avatar wrapper component.
 */
export const getAvatarDims = (
	size: number,
	disableWrapper = false,
	padding = true,
	radius = true,
	borderWidth?: number,
): AvatarDims => {
	if (disableWrapper) return [0, 0, 0, size, 0]

	borderWidth ??= clamp(Math.floor(size * 0.03), 3, 8)
	const boxPadding = padding ? clamp(Math.floor(size * 0.02), 2, 5) : 0
	const innerSize = size - 2 * (borderWidth + boxPadding)

	const innerRadius = radius ? innerSize / 2 : 0
	const outerRadius = radius ? size / 2 : 0

	return [borderWidth, boxPadding, innerRadius, innerSize, outerRadius]
}
